define('pages/settings/settings_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/settings_form/settings_form_view',

  'text!./settings_page_template.html'

], function (Backbone, $, _, SettingsFormView, settings_page_template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (options) {

      this.subViews = [];

      this.settings_form = new SettingsFormView();
      this.subViews.push(this.settings_form);

      this.render();

      this.renderSubView();
    },

    template: _.template(settings_page_template),
    subViews: [],

    render: function () {

      this.$el.html(this.template());

      return this;
    },

    renderSubView: function () {
      this.$('.settings-page-content').html(this.settings_form.$el);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});
